import * as React from 'react';
import {Helmet} from 'react-helmet';
import CreateTeamForm from '../../containers/CreateTeamForm';
import Card, {CardHeader, CardBody} from '../../components/Card';

export default class CreateTeam extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Create your new team</title>
        </Helmet>
        <Card>
          <CardHeader>Create a new team</CardHeader>
          <CardBody>
            <CreateTeamForm />
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CreateTeam/CreateTeam.tsx